// import React, { useState } from "react";
// import RoleToggle from "../../../components/RoleToggle";
// import RoleManagement from "./RoleManagement";
// import NormalSearch from "../../../components/common/NormalSearch";
// import AccessManagement from "./AccessManagement";

// const AccessControlManagement: React.FC = () => {
//   const [activeRole, setActiveRole] = useState("Role Access");
//   const roles = ["Role Access", "Client Access"];

//   return (
//     <div className=" space-y-4">
//       <div className="flex justify-between items-center">
//         <RoleToggle
//           options={roles}
//           active={activeRole}
//           onChange={setActiveRole}
//         />
//         <div className="flex items-center gap-2">
//           <NormalSearch />
//         </div>
//       </div>

//       <div className="">
//         {activeRole === "Role Access" && <RoleManagement />}
//         {activeRole === "Client Access" && <AccessManagement />}
//       </div>
//     </div>
//   );
// };
// export default AccessControlManagement;

// import React, { useState } from "react";
// import RoleManagement from "./RoleManagement";
// import AccessManagement from "./AccessManagement";
// import NewCommonModal from "../../../components/common/NewCommonModal";

// type AccessType = "Role Access" | "Client Access";

// const AccessControlManagement: React.FC = () => {
//   const [activeRole, setActiveRole] = useState<AccessType>("Role Access");
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const handleCardClick = (type: AccessType) => {
//     setActiveRole(type);
//     setIsModalOpen(true);
//   };

//   const isRoleAccess = activeRole === "Role Access";

//   return (
//     <div className="w-full flex justify-center items-center min-h-[400px]">
//       {/* 🔹 Cards */}
//       <div className="flex justify-center items-center gap-4 flex-wrap">
//         {/* Role Access */}
//         <div
//           onClick={() => handleCardClick("Role Access")}
//           className="cursor-pointer border rounded-full flex justify-center items-center transition bg-white hover:shadow hover:scale-[1.02] w-40 h-40"
//         >
//           <h3 className="text-lg font-semibold">Role Access</h3>
//         </div>

//         {/* Client Access */}
//         <div
//           onClick={() => handleCardClick("Client Access")}
//           className="cursor-pointer border rounded-full flex justify-center items-center transition bg-white hover:shadow hover:scale-[1.02] w-40 h-40"
//         >
//           <h3 className="text-lg font-semibold">Client Access</h3>
//         </div>
//       </div>

//       {/* 🔹 Modal */}
//       <NewCommonModal
//         classWidth="w-10/12"
//         title={isRoleAccess ? "Add Role" : "Add Client Access"}
//         open={isModalOpen}
//         closeButtonText="Cancel"
//         onClose={() => setIsModalOpen(false)}
//       >
//         {isRoleAccess ? <RoleManagement /> : <AccessManagement />}
//       </NewCommonModal>
//     </div>
//   );
// };

// export default AccessControlManagement;

import React, { useState } from "react";

import RoleManagement from "./RoleManagement";
import AccessManagement from "./AccessManagement";
import {
  IconChevronRight,
  IconShieldCheck,
  IconUsers,
} from "@tabler/icons-react";
import { T, useLanguage } from "../../../context/LanguageContext";

type AccessType = "Role Access" | "Client Access";

const AccessControlManagement: React.FC = () => {
  const { t } = useLanguage();
  const [activeRole, setActiveRole] = useState<AccessType>("Role Access");

  const cards = [
    {
      title: "Role Access",
      icon: IconShieldCheck,
      description: "Manage roles and permissions",
    },
    {
      title: "Client Access",
      icon: IconUsers,
      description: "Manage client access rights",
    },
  ];

  return (
     <div className="">
        <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        {/* Left Side */}
        <div className="lg:col-span-3">
          <div className="bg-white rounded-3xl border border-gray-200 p-5 shadow-sm">
            <h2 className="text-xl font-bold text-gray-900 mb-1">
              <T>Access Control</T>
            </h2>

            <p className="text-sm text-gray-500 mb-6">
              <T>Select a module to manage permissions.</T>
            </p>

            <div className="space-y-4">
              {cards.map((card) => {
                const Icon = card.icon;
                const isActive = activeRole === card.title;

                return (
                  <button
                    key={card.title}
                    onClick={() => setActiveRole(card.title as AccessType)}
                    className={`w-full p-4 rounded-2xl border transition-all duration-300 text-left group ${
                      isActive
                        ? "border-[#FBD037] bg-[#FFFBEA] shadow-sm"
                        : "border-gray-200 bg-white hover:border-[#FBD037]"
                    }`}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div
                          className={`w-12 h-12 rounded-xl flex items-center justify-center ${
                            isActive ? "bg-[#FBD037]/20" : "bg-gray-100"
                          }`}
                        >
                          <Icon className="w-6 h-6 text-[#212121]" />
                        </div>

                        <div>
                          <h3 className="font-semibold text-[#212121]">
                            <T>{card.title}</T>
                          </h3>

                          <p className="text-sm text-gray-500">
                            <T>{card.description}</T>
                          </p>
                        </div>
                      </div>

                      <IconChevronRight
                        className={`w-5 h-5 transition ${
                          isActive ? "text-[#FBD037]" : "text-gray-400"
                        }`}
                      />
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {/* Right Side */}
        <div className="lg:col-span-9">
          <div className="bg-white rounded-3xl border border-gray-200 shadow-sm min-h-[600px] overflow-hidden">
            <div className="border-b px-6 py-4 bg-white">
              <h2 className="text-lg font-bold text-[#212121]"><T>{activeRole}</T></h2>
            </div>

            <div className="">
              {activeRole === "Role Access" ? (
                <RoleManagement />
              ) : (
                <AccessManagement />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessControlManagement;
